import pluralize from 'pluralize';
import { useContext } from 'react';
import { CreatedByAiLabel } from '@/modules/common/components/CreatedByAiLabel.tsx';
import { DeleteModal } from '@/modules/admin-dashboard/components/modals/DeleteModal.tsx';
import { RenameModal } from '@/modules/admin-dashboard/components/modals/RenameModal.tsx';
import { UpdateDepartmentModal } from '@/modules/admin-dashboard/components/modals/UpdateDepartmentModal.tsx';
import {
  useDeleteDepartmentMutation,
  useUpdateDepartmentMutation,
} from '@/modules/admin-dashboard/queries/department.ts';
import { DisclosureListItem, DropdownMenu, ModalProviderContext } from 'ui';
import { DotsHorizontalIcon } from 'ui/icons';
import { DepartmentResponse } from 'compliance-api';

interface DepartmentItemProps {
  department: DepartmentResponse;
}

const DepartmentItem = ({ department }: DepartmentItemProps) => {
  const { openModal } = useContext(ModalProviderContext);
  return (
    <DisclosureListItem
      leftMainString={department.name}
      leftSubduedContentSet={[
        `${department.users_count} ${pluralize('user', department.users_count)}`,
        `${department.tasks_count} ${pluralize('task', department.tasks_count)}`,
        <CreatedByAiLabel created_with_ai={department.created_with_ai} />,
      ]}
      rightContent={
        <DropdownMenu
          autoPlace
          items={[
            {
              label: 'Manage Users',
              onClick: () => {
                openModal(UpdateDepartmentModal, {
                  departmentId: department?.id || 0,
                  departmentName: department?.name || '',
                });
              },
            },
            {
              label: 'Rename',
              onClick: () => {
                openModal(RenameModal, {
                  title: 'Department',
                  name: department?.name || '',
                  id: department?.id || 0,
                  mutation: useUpdateDepartmentMutation,
                });
              },
            },
            {
              label: 'Delete',
              onClick: () =>
                openModal(DeleteModal, {
                  name: department?.name || '',
                  id: department?.id || 0,
                  mutation: useDeleteDepartmentMutation,
                  title: 'Department',
                }),
            },
          ]}
          button={
            <button className="flex items-center justify-center">
              <img src={DotsHorizontalIcon} alt="Loading..." />
            </button>
          }
          className="w-[180px] divide-white"
        />
      }
    />
  );
};

export default DepartmentItem;
